import React from 'react';
import { Dropdown, Button } from 'antd';
import { MailOutlined, WhatsAppOutlined, MessageOutlined } from '@ant-design/icons';

export type InviteMethod = 'whatsapp' | 'email' | 'sms';

interface InviteDropdownProps {
  name: string;
  onInvite: (method: InviteMethod) => void | Promise<void>;
}

const InviteDropdown: React.FC<InviteDropdownProps> = ({ onInvite }) => {
  const items = [
    {
      key: 'whatsapp',
      icon: <WhatsAppOutlined />,
      label: 'WhatsApp',
    },
    {
      key: 'email',
      icon: <MailOutlined />,
      label: 'Email',
    },
    {
      key: 'sms',
      icon: <MessageOutlined />,
      label: 'SMS',
    },
  ];

  return (
    <Dropdown
      menu={{
        items,
        onClick: ({ key }) => onInvite(key as InviteMethod),
      }}
      placement="bottom"
    >
      <Button>Invite</Button>
    </Dropdown>
  );
};

export default InviteDropdown; 